export default __webpack_public_path__ + "static/media/Chris-Bannon.ce7dc59c.jpg";